import { Component } from '@angular/core';
import { EnvironmentVariablesService } from '@kenv';
import { productDisplayName } from '@kservice';
import { Product } from '@ktypes/enums';

@Component({
  selector: 'kp-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
})
export class HelpComponent {
  constructor(private _environmentVariablesService: EnvironmentVariablesService) {}

  appVersion = this._environmentVariablesService.versions.app[this._environmentVariablesService.product];
  isPurposeful = this._environmentVariablesService.product === Product.purposeful;
  isResourceful = this._environmentVariablesService.product === Product.resourceful;
  productName = productDisplayName;
  revision = this._environmentVariablesService.versions.revision;
  version = this._environmentVariablesService.latestVersion;
}
